'use strict';
var mpangoApp =  angular.module('mpangoApp', ['ui.router', 'satellizer','ui.bootstrap','ui-notification','ngFileUpload','oitozero.ngSweetAlert','xeditable','ngMessages','angularUtils.directives.dirPagination','angular-loading-bar','angularMoment']);
mpangoApp.config(['$stateProvider', '$urlRouterProvider', '$authProvider', '$httpProvider', '$provide',function($stateProvider, $urlRouterProvider, $authProvider, $httpProvider, $provide) {
    function redirectWhenLoggedOut($q, $injector) {
        return {
            responseError: function(rejection) {
                var $state = $injector.get('$state');
                var rejectionReasons = ['token_not_provided', 'token_expired', 'token_absent', 'token_invalid'];
                angular.forEach(rejectionReasons, function(value, key) {

                    if(rejection.data.error === value) {
                        localStorage.removeItem('user');
                        $state.go('auth');
                    }
                });
                return $q.reject(rejection);
            }
        }
    }
    $provide.factory('redirectWhenLoggedOut', redirectWhenLoggedOut);
    $httpProvider.interceptors.push('redirectWhenLoggedOut');
    $authProvider.loginUrl = '/api/authenticate';
    $authProvider.signupUrl = '/api/signup';
    $urlRouterProvider.otherwise('/auth');
    $stateProvider
        .state('auth', {
            url: '/auth',
            templateUrl: '../views/authView.html',
            controller: 'AuthController as auth',
            wekabg:'pichas'
        })
        .state('msignup', {
            url: '/msignup',
            templateUrl: '../views/msignup.html',
            controller: 'AuthController as auth',
            wekabg:'pichas'
        })
        .state('pwdreset', {
            url: '/pwdreset',
            templateUrl: '../views/pwdreset.html',
            controller: 'AuthController as auth',
            wekabg:'pichas'
        })
        .state('about', {
            url: '/about',
            templateUrl: '../views/about.html',
            controller: 'AuthController as auth'
        })
        .state('tutorial', {
            url: '/tutorial',
            templateUrl: '../views/tutorial.html',
            controller: 'AuthController as auth'
        })
        .state('mtodos', {
            url: '/mtodos',
            templateUrl: '../views/mtodo.html',
            controller: 'MtodoController'
        })
        .state('dashboard', {
            url: '/dashboard',
            templateUrl: '../views/dashboard.html',
            controller: 'DashboardController'
        })
        .state('mactilogs', {
            url: '/mactilogs',
            templateUrl: '../views/mactilogs.html',
            controller: 'MactivitylogController'
        })
        .state('mcontributions', {
            url: '/mcontributions',
            templateUrl: '../views/mcontributions.html',
            controller: 'McontributionsController'
        })
        .state('mevents', {
            url: '/mevents',
            templateUrl: '../views/mevents.html',
            controller: 'MeventController'
        })
        .state('mbudget', {
            url: '/mbudget',
            templateUrl: '../views/mbudget.html',
            controller: 'MbudgetController'
        })
        .state('mvendors', {
            url: '/mvendors',
            templateUrl: '../views/mvendors.html',
            controller: 'MvendorController'
        })
        .state('musers', {
            url: '/musers',
            templateUrl: '../views/musers.html',
            controller: 'MuserController as user'
        })
        .state('eventusers', {
            url: '/eventusers',
            templateUrl: '../views/eventusers.html',
            controller: 'MeventuserController'
        })
        .state('msentbox', {
            url: '/msentbox',
            templateUrl: '../views/msentbox.html',
            controller: 'MsmsController'
        });
}])
.run(['$rootScope', '$state',function($rootScope, $state) {
    $rootScope.$on('$stateChangeStart', function(event, toState) {
        var user = JSON.parse(localStorage.getItem('user'));            
        if(user) {
            $rootScope.authenticated = true;
            $rootScope.currentUser = user;
            $rootScope.sytoken = localStorage.satellizer_token;
            if(toState.name === "auth") {
                event.preventDefault();
                $state.go('dashboard');
            }       
        }
    });
    $rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams){
        $rootScope.wekabg = toState.wekabg;
      });
}])
.config(['NotificationProvider',function(NotificationProvider) {
    NotificationProvider.setOptions({
        delay: 1500,
        startTop: 20,
        startRight: 10,
        verticalSpacing: 20,
        horizontalSpacing: 20,
        positionX: 'center',
        positionY: 'top'
    });
}])
.config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
    // cfpLoadingBarProvider.latencyThreshold = 500;
  }]);
